export const messages = {
  en: {
    wrongNetwork: "Please use Metamask and switch to {network} network.",
    wrongBrowser:
      "Please use a browser that supports <a href='https://metamask.io' target='_blank' no-follow rel='nofollow'>MetaMask</a>.",
    loginMetaMask: "Please login MetaMask.",
    invalidGrid: "This grid is not public right now, please try later.",
    signSuccess: "Success",
    signFail: "Failed to verify signer.",
    selectLang: "Language",
    buy: "Buy",
    cancel: "Cancel",
    save: "Save",
    buyTip1:
      "When you have this grid, you can upload a picture, set up a link and write some text.",
    buyTip2: "If someone buys this grid, you can get eth.",
    menu: {
      home: "Home",
      mygrid: "My Grid",
      faq: "FAQ",
      terms: "Terms of Use",
      privacy: "Privacy Policy",
      disclaimer: "Disclaimer",
      feedback: "Feedback"
    },
    faq: {
      q1: "<i class='fas fa-caret-right'></i> What is ETH?",
      a1:
        "ETH is the cryptocurrency used in the Ethereum Platform - which is an open sourced software platform based on blockchain technology that enables developers to build and deploy decentralized applications.",
      q2: '<i class="fas fa-caret-right"></i> What is ETH Grid?',
      a2: `<p>ETHGrid is an interactive game that lets anyone buy and own grids as Smart Contracts on the Ethereum Blockchain. As soon as you acquire a grid, you take ownership of that nation and it automatically increases in price.</p>`,
      q3: '<i class="fas fa-caret-right"></i> The model of price increase.',
      a3: `<p>
        Each grid's price from 0.1 ETH.<br>
        The price increase is hard coded into the smart contract and follow this model:</p>
        <table class="table">
        <thead><tr>
        <th>Value Increase Levels</th>
        <th>Price Range</th>
        <th>Price Increase</th>
        <th>Dev Cut</th>
        </tr></thead>
        <tbody><tr>
        <td>Increase 1</td>
        <td>0.1 - 0.5 ETH</td>
        <td>40%</td>
        <td>4%</td>
        </tr>
        <tr>
        <td>Increase 2</td>
        <td>0.5 - 2.0 ETH</td>
        <td>29%</td>
        <td>3%</td>
        </tr>
        <tr>
        <td>Increase 3</td>
        <td>2.0 - 5.0 ETH</td>
        <td>20%</td>
        <td>3%</td></tr>
        <tr>
        <td>Increase 4</td>
        <td>5.0 ETH - </td>
        <td>17%</td>
        <td>2%</td>
        </tr>
        </tbody></table>
        `,
      q4:
        '<i class="fas fa-caret-right"></i> If someone buys and conquers my grid...',
      a4: `
        <p>The grids are visible on the Ethereum Blockchain as smart contracts. Meaning, they can only be acquired using Ether. Each grid contract works similarly to a token or a coin and can only be owned by one individual.</p>
        <p>You can conquer any available grid on the page. Anyone else can also purchase and conquer your owned grids as long as they pay you the new price calculated from the smart contract after you acquired the grid previously.</p>
        `,
      q5: '<i class="fas fa-caret-right"></i> What do I need to play ETH Grid?',
      a5: `<p>Here is what you need to started:</p>

        <ul><li>A computer or laptop running the desktop version of Chrome or Firefox</li>
        <li><a href="https://metamask.io/" target="_blank">MetaMask</a>, a digital wallet used specifically with web apps</li>
        <li>Ether, a form of digital payment that powers ETH Grid</li>
        </ul>`,
      q6:
        '<i class="fas fa-caret-right"></i> Installing MetaMask, your digital wallet',
      a6: `
        <p>To use ETH Grid, you will need to install MetaMask, a digital wallet. You will need to put ETH in it to make your first purchase.</p>
        <p>Note: A digital wallet like MetaMask acts like a bank account—treat it with respect and make sure you don’t forget your password or the seed words.</p>
        `,
      q7: '<i class="fas fa-caret-right"></i> How to send ETH to MataMask',
      a7: `<p>
        <span class="badge badge-success">For U.S. citizens only:</span> you are able to purchase ETH directly from the MetaMask wallet using the Coinbase widget. This is more convenient and doesn’t require you to create two accounts.</p>
        <p>
        <span class="badge badge-success">For everyone else:</span> you need to buy ETH from an exchange using normal fiat currency. Copy your MetaMask address by clicking on the large ‘...’ next to your account, then select ‘Copy Address to clipboard’. Go to your exchange, click ‘Accounts’, and select your ETH Wallet and click ‘send’. Paste the MetaMask address in the box with the amount you’d like to transfer.</p>
        `
    },
    grid: {
      invalidGrid: "This grid is not public right now, please try later.",
      currentPrice: "Current Price: ",
      nextPrice: "Next Price: ",
      thisIsYourGrid: "You are the owner",
      modifyGrid: "Modify",
      pendingTx: "The transaction is waiting for confirmation.",
      orderSubmitted:
        "The transaction was placed in Ethereum, which may take a few minutes. When the transaction confirmation exceeds 16, this grid will appear in your grid list"
    },
    my: {
      myGrid: "My Grid",
      uploadPic: "Upload a Picture",
      changePic: "Change a Picture",
      wrongFileType: "We do not support this file type.",
      wrongFileSize: "File size must not exceed",
      wrongDevice: "Your device does not support uploading files.",
      saveSuccess: "Success.",
      textPlaceholder: "Input text...",
      haveNoGrid:
        "You don't have any grid. Please buy it on the <a href='/'>Home</a>.",
      signTip: "Please sign in MetaMask to confirm your identity.",
      checkForm: "Please correct the errors!"
    }
  },
  cn: {
    wrongNetwork: "请切换至{network}网络。",
    wrongBrowser:
      "请使用已安装<a href='https://metamask.io' target='_blank' no-follow rel='nofollow'>MetaMask插件</a>的浏览器。",
    loginMetaMask: "获取账户失败，请登录MetaMask。",
    invalidGrid: "该区域尚未开放，请稍后再试。",
    signSuccess: "验证通过",
    signFail: "验证签名失败",
    selectLang: "选择语言",
    buy: "购买",
    cancel: "取消",
    save: "保存",
    buyTip1: "购买成功后，你可以上传图片、文字以及链接。",
    buyTip2: "当其他用户购买你的格子时，你将会自动获得出售带来的收益。",
    menu: {
      home: "首页",
      mygrid: "我的格子",
      faq: "常见问题",
      terms: "使用条款",
      privacy: "隐私协议",
      disclaimer: "免责声明",
      feedback: "意见反馈"
    },
    faq: {
      q1: "<i class='fas fa-caret-right'></i> ETH 是什么",
      a1: "和比特币一样，ETH一种数字货币。",
      q2: '<i class="fas fa-caret-right"></i> ETH Grid（以太格子）是什么？',
      a2:
        "<p><ul><li>ETH Grid（以太格子）是基于Ethereum Smart Contract的一款去中心化应用。</li><li>其中每一个格子都是符合Ethereum ERC-721协议的一个TOKEN。</li><li>任何人都可以使用 ETH 在50x50的矩阵中换取对所选格子的使用权。拥有使用权时你可以对格子上传图片或编辑文字内容，互联网上的任何人在访问该网站时都会看到你的格子。</li><li>当有人想要获得你所拥有的格子时，需按照价格增长规则使用ETH进行兑换，兑换成功后你将自动失去该格子的使用权并将获得对方支付的 ETH。</li></ul></p>",
      q3:
        '<i class="fas fa-caret-right"></i> ETH Grid（以太格子）的价格增长规则',
      a3: `<P>ETH Grid（以太格子）在合约中确定了每个格子共有5档价格：</p>
        <ul>
          <li>初始价格为 0.1 ETH</li>
          <li>0.1 - 0.5 ETH 时 增长率约等于 1.4 倍</li>
          <li>0.5 - 2.0 ETH 时 增长率约等于 1.29 倍</li>
          <li>2.0 - 5.0 ETH 时 增长率约等于 1.2 倍</li>
          <li>超过 5.0 ETH 时 增长率约等于 1.17 倍</li>
        </ul>`,
      q4:
        '<i class="fas fa-caret-right"></i> 如何从Eth Grid（以太格子）获得收益',
      a4:
        "当有人兑换你所有拥有的格子时，Smart Contract 会自动将兑换的 ETH 转入至你的钱包地址。",
      q5:
        '<i class="fas fa-caret-right"></i> 玩ETH Grid（以太格子）需要准备什么？',
      a5: `<p><ul><li>一台可以连接互联网并且运行Chrome 或 Firefox 浏览器的电脑。</li>
        <li>安装 <a href="https://metamask.io/" target="_blank">MetaMask</a> 数字钱包插件，你购买的所有格子将会和MetaMask内的钱包地址绑定。</li>
        <li>你的 <a href="https://metamask.io/" target="_blank">MetaMask</a> 钱包内应当准备一些ETH，用来支付购买格子产生的费用，该钱包地址也将接收格子售出时获得的收益。</li></ul></p>`,
      q6: '<i class="fas fa-caret-right"></i> 如何安装MetaMask数字钱包',
      a6: `<p><a href="https://metamask.io/" target="_blank">MetaMask</a> 是一款数字钱包插件。使用 Eth Grid（以太格子）你需要首先安装MetaMask。</p>
        <p class="text-danger"><strong>注意：</strong> 数字钱包如同银行账户，请你谨慎保管密码和助记词。Eth Grid（以太格子）无法帮你找回钱包密码。</p>`,
      q7: '<i class="fas fa-caret-right"></i> 如何获取Ether（以太坊）',
      a7:
        '您可以在MetaMask中购买ETH，也可以在<a href="https://nanodapp.com/tag/31" target="_blank">数字货币交易平台</a>中购买ETH并转账至你的MetaMask钱包地址中。'
    },
    grid: {
      invalidGrid: "该区域尚未开放，请稍后再试。",
      currentPrice: "当前售价：",
      nextPrice: "下次售价：",
      thisIsYourGrid: "您拥有这个格子",
      modifyGrid: "修改格子内容",
      pendingTx: "这个格子当前正在交易确认中。",
      orderSubmitted: "购买请求已发送，稍后请在我的格子中查看。"
    },
    my: {
      myGrid: "我的格子",
      uploadPic: "上传一张图片",
      changePic: "更换图片",
      wrongFileType: "该文件类型不支持。",
      wrongFileSize: "文件大小不得超过",
      wrongDevice: "当前设备不支持文件上传",

      saveSuccess: "保存成功",
      textPlaceholder: "输入文字",
      haveNoGrid:
        "你目前还没有拥有任何格子，请在<a href='/'>首页</a>进行购买。",
      signTip: "请先在 MetaMask 中签名信息以确认您的身份。",
      checkForm: "填写的内容有误，请检查。"
    }
  }
};
